import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ImplementForEquipmentDetails, UpdateSMUReadingModel, ChangeMeterUnitModel, InspectionDetailGroupByDate, ImplementSortOrderForUser, ImplementSortOrder, ImplementHistoryVM, ImplementForEquipmentDetailsDFI, OBSActionHistoryDFI } from './equipment-details.model';
import { EquipmentDetailsParams, Tuple } from '../setup-equipment/setup-equipment.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { RemoveImplementModalData } from '../remove-implement-modal/remove-implement-modal';
import { DatePipe } from '@angular/common';


@Injectable()
export class EquipmentDetailsService {

  constructor(private _http: Http, private newHttp: HttpClient, private _datePipe: DatePipe) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public getEquipmentDetails(equipmentId: number): Observable<EquipmentDetailsParams> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/equipmentdetails/GetEquipmentDetails', { search: params }).share().map(
      (response: Response) => <EquipmentDetailsParams>response.json()).catch(this.handleError);
  }

  public GetImplementsAndSchematics(equipmentId: number): Observable<ImplementForEquipmentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/equipmentdetails/GetImplementsAndSchematics', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  }

  public GetImplementsAndSchematicsForDFI_(equipmentId: number): Observable<ImplementForEquipmentDetailsDFI[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/GETDashboard/GetImplementsAndComponentQuestion', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetailsDFI[]>response.json()).catch(this.handleError);
  }

  public GetImplementsAndSchematicsForDFI(equipmentId: number): Observable<ImplementForEquipmentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/equipmentdetails/GetImplementsAndSchematicsForDFI', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  }

  public GetGETWearSurfaceReportStyle(equipmentId: number, implementId?: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());

    if (implementId !== undefined && implementId !== null) {
      params.set('implementId', implementId.toString());
    }
    return this._http.get('api/equipmentdetails/GetGETWearSurfaceReportStyle', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public GetGETWearSurfaceReportStyle_(equipmentId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get('api/equipmentdetails/GetGETWearSurfaceReportStyle', options).pipe(catchError(this.handleError));
  }

  public GetEquipmentInspectionHistory(equipmentId: number): Observable<InspectionDetailGroupByDate[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/equipmentdetails/GetEquipmentInspectionHistory', { search: params }).share().map(
      (response: Response) => <InspectionDetailGroupByDate[]>response.json()).catch(this.handleError);
  }


  public GetInspectionsByEquipmentIdAndDate(equipmentId: number, date: Date) {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('selectedDate', date.toString())
    };
    return this.newHttp.get('api/equipmentdetails/GetInspectionsByEquipmentAndDate', options).pipe(catchError(this.handleError));
  }

  public changeSMUReading(updateModel: UpdateSMUReadingModel): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', updateModel.equipmentId.toString());
    params.set('currentReading', updateModel.currentReading.toString());
    params.set('dateReadSMU', updateModel.dateReadSMU.toDateString());
    params.set('bcm', updateModel.bcm.toString());
    params.set('ton', updateModel.ton.toString());
    params.set('startDate', updateModel.startDate.toDateString());
    params.set('endDate', updateModel.endDate.toDateString());
    return this._http.get('api/equipmentdetails/UpdateEquipmentSMU', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }
  public changeSMUReadingAssetRepair(updateModel: UpdateSMUReadingModel): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', updateModel.equipmentId.toString());
    params.set('currentReading', updateModel.currentReading.toString());
    params.set('dateReadSMU', updateModel.dateReadSMU.toDateString());
    params.set('bcm', updateModel.bcm.toString());
    params.set('ton', updateModel.ton.toString());
    params.set('startDate', updateModel.startDate.toDateString());
    params.set('endDate', updateModel.endDate.toDateString());
    return this._http.get('api/equipmentdetails/UpdateEquipmentSMUAssetRepair', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public changeEquipmentBCMTonsReading(updateModel: UpdateSMUReadingModel, ImplementId: number): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', updateModel.equipmentId.toString());
    params.set('bcm', updateModel.bcm.toString());
    params.set('ton', updateModel.ton.toString());
    params.set('startDate', updateModel.startDate.toDateString());
    params.set('endDate', updateModel.endDate.toDateString());
    params.set('ImplementId', ImplementId.toString());
    return this._http.get('api/equipmentdetails/UpdateEquipmentBCMTonsForPeriod', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }


  public GetSMUReadingHistory(equipmentId: number, ImplementId: number) {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('ImplementId', ImplementId.toString())
    };
    return this.newHttp.get('api/equipmentdetails/GetSMUUsageHistory', options).pipe(catchError(this.handleError));
  }


  public changeEquipmentJobsite(equipmentId: number, jobsiteId: number): Observable<Tuple> {
    let params = { equipmentId: equipmentId, jobsiteId: jobsiteId };
    return this._http.get('api/equipmentdetails/ChangeEquipmentJobsite', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public changeInventoryJobsite(get_auto: number, jobsiteId: number): Observable<Tuple> {
    let params = { get_auto: get_auto, jobsiteId: jobsiteId };
    return this._http.get('api/Implement/ChangeInventoryJobsite', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public changeMeterUnit(changeUnitModel: ChangeMeterUnitModel): Observable<Tuple> {
    return this._http.post('api/equipmentdetails/ChangeMeterUnit', changeUnitModel).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);

  }


  public saveRemoveImplement(data: RemoveImplementModalData): Observable<string> {
      let params: URLSearchParams = new URLSearchParams();
      params.set('implementId', data.implementId.toString());
      params.set('jobsiteId', data.jobsiteId.toString());
      params.set('equipmentId', data.equipmentId.toString());
      params.set('smu', data.smu.toString());
      params.set('cost', data.cost.toString());
    params.set('date', this._datePipe.transform(data.date, 'MM/dd/yyyy'));
      params.set('comment', data.comment.toString());
      params.set('statusId', data.status.toString());
      params.set('repairerId', data.repairerId.toString());
      params.set('workshopId', data.workshopId.toString());
      return this._http.get("api/Implement/MoveImplementToInventory", { search: params }).share().map(
          (response: Response) => <string>response.json()).catch(this.handleError);
  }



  public SaveImplementSortOrder(params: ImplementSortOrderForUser): Observable<number> {
    return this._http.post('api/equipmentdetails/SaveImplementSortOrder', params).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public GetImplementSortOrderforUser(equipmentId: number): Observable<ImplementSortOrder[]> {
    let params = { equipmentId: equipmentId };
    return this._http.get('api/equipmentdetails/GetImplementSortOrderForuser', { search: params }).share().map(
      (response: Response) => <ImplementSortOrder[]>response.json()).catch(this.handleError);
  }

  public GetImplementsHistoryByEquipment(equipmentId: number): Observable<ImplementHistoryVM[]> {
    let params = { equipmentId: equipmentId };
    return this._http.get('api/equipmentdetails/GetImplementsHistoryForEquipment', { search: params }).share().map(
      (response: Response) => <ImplementHistoryVM[]>response.json()).catch(this.handleError);
  }

  public GetAssestDetailHistroyInfoDFI(equipmentId: number): Observable<ImplementForEquipmentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/Implement/GetAssestDetailHistroyInfoDFI', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  }

  public GetDFIInspectionHistory(equipmentId: number): Observable<OBSActionHistoryDFI[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('equipmentId', equipmentId.toString());
    return this._http.get('api/Implement/GetDFIInspectionHistory', { search: params }).share().map(
      (response: Response) => <OBSActionHistoryDFI[]>response.json()).catch(this.handleError);
  }

}
